import React, { Component } from 'react'
import { Link } from 'react-router'
import moment from 'moment'
import { getProperty, normaliseMap } from './utils'
import { BooleanList, Icon } from './misc'

import Header from './header'

/* eslint-disable react/prop-types */

class Profile extends Component {
    componentWillMount() {
        // load personal data
        if (! this.props.personal.data) {
            this.props.personalActions.loadPersonal(this.props.account.user.crew.uuid)
        }

        // load experience data
        if (! this.props.personal.experience) {
            this.props.personalActions.loadExperience(this.props.account.user.crew.uuid)
        }

        // load in supporting daat
        if (! this.props.crew.insurance_type) {
            this.props.crewActions.loadInsuranceTypes()
        }
        if (! this.props.crew.industry_type) {
            this.props.crewActions.loadIndustryTypes()
        }
        if (! this.props.crew.language) {
            this.props.crewActions.loadLanguages()
        }
    }

    _getInsuranceSelections() {
        if (! this.props.crew.insurance_type) {
            return []
        }

        return this.props.crew.insurance_type
            .filter((item) => getProperty(this.props.personal.data.insurance_map, item.uuid) === '1')
            .map((item) => item.uuid)
    }

    render() {
        const { data: user, photo, experience } = this.props.personal

        if (! user || ! experience) {
            return null
        }

        // prep some data for render
        let photoURL = '/img/profile-avatar.png'

        if (photo && photo.photo) {
            photoURL = `${ photo.photo }`
        }

        const genderIcon = user.sex === 'MALE' ? 'male' : 'female'

        // get list of crewtypes and compile gear details
        const crewTypes = [ <li key="primary">{ user.type_obj.label }</li> ]

        if (user.crew_secondary_type) {
            crewTypes.push(<li key="secondary">{ user.crew_secondary_type_obj.label }</li>)
        }
        if (user.crew_tertiary_type) {
            crewTypes.push(<li key="tertiary">{ user.crew_tertiary_type_obj.label }</li>)
        }
        if (user.additional_crew_type) {
            for (const item of user.additional_crew_type_obj) {
                crewTypes.push(<li key={ `additional-${ item.identifier }` }>{ item.label }</li>)
            }
        }

        return (
            <div>
                <Header title="My Profile" />

                <div className="content">
                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Personal Details

                                    <div style={{ float: 'right' }}>
                                        <Link to="/personal">
                                            <Icon icon="gear" label="Update Info" large />
                                            Update Info
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <div className="grid grid--break-mobile">
                                    <div className="grid__span-4">
                                        <img src={ photoURL } style={{ maxWidth: '100%' }} />
                                    </div>
                                    <div className="grid__span-8">
                                        <div className="grid grid--break-mobile">
                                            <div className="grid__span-4">
                                                <p className="heading">
                                                    { user.first_name }
                                                    { ' ' }
                                                    { user.last_name }
                                                    { ' ' }
                                                    <Icon icon={ genderIcon } />
                                                </p>
                                                <ul className="fa-ul">
                                                    <li>
                                                        <Icon icon="mobile" label="Cell Phone" large list />
                                                        <a
                                                            href={
                                                                (user.mobile_phone_dial_code) ?
                                                                    `tel:+${ user.mobile_phone_dial_code_obj.dial_code }${ user.mobile_phone }` :
                                                                    `tel:${ user.mobile_phone }`
                                                            }
                                                        >
                                                            {
                                                                (user.mobile_phone_dial_code) ?
                                                                    `+${ user.mobile_phone_dial_code_obj.dial_code } ${ user.mobile_phone }` :
                                                                    `${ user.mobile_phone }`
                                                            }
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <Icon icon="envelope" label="Email Address" list />
                                                        <a href={ `mailto:${ user.email }` }>
                                                            { user.email }
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <Icon icon="calendar" label="Date of Birth" list />
                                                        { moment(user.dob).format('MMMM D, Y') }
                                                    </li>
                                                </ul>

                                                <p className="heading">Emergency Contact</p>
                                                <ul className="fa-ul">
                                                    <li>
                                                        <Icon icon="user" label="Name" list />
                                                        { user.emergency_contact_name }
                                                    </li>
                                                    <li>
                                                        <Icon icon="mobile" label="Cell Phone" large list />
                                                        <a
                                                            href={
                                                                (user.emergency_contact_cell_dial_code) ?
                                                                    `tel:+${ user.emergency_contact_cell_dial_code_obj.dial_code }${ user.emergency_contact_cell }` :
                                                                    `tel:${ user.emergency_contact_cell }`
                                                            }
                                                        >
                                                            {
                                                                (user.emergency_contact_cell_dial_code) ?
                                                                    `+${ user.emergency_contact_cell_dial_code_obj.dial_code } ${ user.emergency_contact_cell }` :
                                                                    `${ user.emergency_contact_cell }`
                                                            }
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <Icon icon="envelope" label="Email Address" list />
                                                        <a href={ `mailto:${ user.emergency_contact_email }` }>
                                                            { user.emergency_contact_email }
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="grid__span-4">
                                                <p className="heading">
                                                    <Icon icon="map-marker" />
                                                    Address
                                                </p>
                                                <p>
                                                    { user.street }
                                                    { user.apt_suite ? <span><br />{ user.apt_suite }</span> : null }
                                                    <br />
                                                    { user.city_name }, { getProperty(user, 'region_obj.label') } { user.zipcode }
                                                    <br />
                                                    { getProperty(user, 'country_obj.label') }
                                                </p>
                                            </div>
                                            <div className="grid__span-4">
                                                <p className="heading">Crew Types</p>

                                                <ol>
                                                    { crewTypes }
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid grid--break-mobile">
                                    <div className="grid__span-6">
                                        <p className="heading">Transportation</p>
                                        <p>
                                            Valid drivers license?
                                            { ' ' }
                                            <Icon
                                                className={
                                                    `label label--${
                                                        user.valid_driving_license === 1 ? 'success' : 'danger'
                                                    }`
                                                }
                                                icon={ user.valid_driving_license === 1 ? 'check' : 'times' }
                                                text={ user.valid_driving_license === 1 ? 'Yes' : 'No' }
                                            />
                                        </p>
                                        <p>
                                            Personal vehicle?
                                            { ' ' }
                                            <Icon
                                                className={
                                                    `label label--${ user.own_car === 1 ? 'success' : 'danger' }`
                                                }
                                                icon={ user.own_car === 1 ? 'check' : 'times' }
                                                text={ user.own_car === 1 ? 'Yes' : 'No' }
                                            />
                                        </p>
                                        { do {
                                            if (user.own_car === 1) {
                                                <ul>
                                                    <li>Type: { user.vehicle_type_verbal }</li>
                                                    <li>Make: { user.vehicle_make_verbal }</li>
                                                    <li>Year: { user.vehicle_year }</li>
                                                    <li>{ user.vehicle_passenger_number_verbal } + self</li>
                                                    <li>Local driving radius: { user.vehicle_local_driving_radius_verbal }</li>
                                                </ul>
                                            }
                                        } }
                                        { do {
                                            if (user.own_car === 1 && user.additional_cities.length) {
                                                (
                                                    <div>
                                                        <p>
                                                            What other cities close to you are you willing to work
                                                            as a local without travel compensation?
                                                        </p>
                                                        <ul>
                                                            { user.additional_cities.map((item) => (
                                                                <li key={ item.uuid }>
                                                                    {
                                                                        [
                                                                            item.city_obj.label,
                                                                            item.city_obj.state,
                                                                            item.city_obj.country_name,
                                                                        ].filter((item) => item).join(', ')
                                                                    }
                                                                </li>
                                                            )) }
                                                        </ul>
                                                    </div>
                                                )
                                            }
                                        } }
                                    </div>
                                    <div className="grid__span-6">
                                        <p className="heading">Insurance Policies</p>

                                        <BooleanList
                                            options={ normaliseMap(this.props.crew.insurance_type) }
                                            selected={ this._getInsuranceSelections() }
                                        />

                                        <p>
                                            Do you have workers compensation insurance?
                                            { ' ' }
                                            <Icon
                                                className={
                                                    `label label--${ user.wrk_cmp === 1 ? 'success' : 'danger' }`
                                                }
                                                icon={ user.wrk_cmp === 1 ? 'check' : 'times' }
                                                text={ user.wrk_cmp === 1 ? 'Yes' : 'No' }
                                            />
                                        </p>

                                        { user.wrk_cmp &&
                                            <div>
                                                <p>Insurance Policy Number: { user.wrk_cmp_policy_number }</p>
                                                <p>Insurance Carrier Name: { user.wrk_cmp_carrier_name }</p>
                                            </div>
                                        }

                                        <p className="heading">Smart Phone</p>

                                        <p>
                                            Do you have a smart phone?
                                            { ' ' }
                                            <Icon
                                                className={
                                                    `label label--${ user.own_smart_phone === 1 ? 'success' : 'danger' }`
                                                }
                                                icon={ user.own_smart_phone === 1 ? 'check' : 'times' }
                                                text={ user.own_smart_phone === 1 ? 'Yes' : 'No' }
                                            />
                                        </p>
                                        { do {
                                            if (user.own_smart_phone === 1) {
                                                <p>
                                                    Smart phone:
                                                    { ' ' }
                                                    { user.smart_phone_os_type_verbal } - { user.smart_phone_model_name }
                                                </p>
                                            }
                                        } }

                                        <p className="heading">Internet Connection</p>

                                        <ul className="list--unstyled">
                                            <li>Type: { user.internet_connection }</li>
                                            <li>Service provider: { user.internet_service_provider }</li>
                                            <li>
                                                Upload: { user.internet_upload_speed_verbal }
                                                { ' ' }
                                                Download: { user.internet_download_speed_verbal }
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Experience Details

                                    <div style={{ float: 'right' }}>
                                        <Link to="/experience">
                                            <Icon icon="gear" label="Update Info" large />
                                            Update Info
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <p className="heading">Work Portfolio</p>
                                <table className="table">
                                    <tbody>
                                        <tr className="table-row">
                                            <th className="table-head-cell span-4">Personal Website</th>
                                            <td className="table-cell span-8">
                                                { experience.website_url &&
                                                    <a href={ experience.website_url }>{ experience.website_url }</a>
                                                }
                                            </td>
                                        </tr>
                                        <tr className="table-row">
                                            <th className="table-head-cell span-4">Direct link to reel</th>
                                            <td className="table-cell span-8">
                                                { experience.demo_reel_url &&
                                                    <a href={ experience.demo_reel_url }>{ experience.demo_reel_url }</a>
                                                }
                                            </td>
                                        </tr>
                                        <tr className="table-row">
                                            <th className="table-head-cell span-4">Vimeo/YouTube Profile</th>
                                            <td className="table-cell span-8">
                                                { experience.video_url &&
                                                    <a href={ experience.video_url }>{ experience.video_url }</a>
                                                }
                                            </td>
                                        </tr>
                                        <tr className="table-row">
                                            <th className="table-head-cell span-4">IMDB Profile</th>
                                            <td className="table-cell span-8">
                                                { experience.imdb_url &&
                                                    <a href={ experience.imdb_url }>{ experience.imdb_url }</a>
                                                }
                                            </td>
                                        </tr>
                                        <tr className="table-row">
                                            <th className="table-head-cell span-4">Additional Personal/Portfolio</th>
                                            <td className="table-cell span-8">
                                                { experience.additional_urls &&
                                                    <a href={ experience.additional_urls }>{ experience.additional_urls }</a>
                                                }
                                            </td>
                                        </tr>
                                        <tr className="table-row">
                                            <th className="table-head-cell span-4">Industry Experience</th>
                                            <td className="table-cell span-8">
                                                <div style={{ columnCount: 3 }}>
                                                    <BooleanList
                                                        options={ normaliseMap(this.props.crew.industry_type) }
                                                        selected={ experience.industry }
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="table-row">
                                            <th className="table-head-cell span-4">Languages Spoken</th>
                                            <td className="table-cell span-8">
                                                <div style={{ columnCount: 3 }}>
                                                    <BooleanList
                                                        options={ normaliseMap(this.props.crew.language) }
                                                        selected={ experience.languages }
                                                    />
                                                    { do {
                                                        if (experience.other_languages) {
                                                            <p>Other: { experience.other_languages }</p>
                                                        }
                                                    } }
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="table-row">
                                            <th className="table-head-cell span-4">Resume</th>
                                            <td className="table-cell span-8">
                                                <a
                                                    className="btn btn--primary"
                                                    href={ experience.resume }
                                                    target="_blank"
                                                >
                                                    View/Download
                                                </a>
                                            </td>
                                        </tr>
                                        <tr className="table-row">
                                            <th className="table-head-cell span-4">Interested in full time job placements</th>
                                            <td className="table-cell span-8">
                                                <Icon
                                                    className={
                                                        `label label--${ experience.job_placement === 1 ? 'success' : 'danger' }`
                                                    }
                                                    icon={ experience.job_placement === 1 ? 'check' : 'times' }
                                                    text={ experience.job_placement === 1 ? 'Yes' : 'No' }
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <p className="heading">References</p>
                                <table className="table">
                                    <thead>
                                        <tr className="table-row">
                                            <th className="table-head-cell">Name</th>
                                            <th className="table-head-cell">Telephone</th>
                                            <th className="table-head-cell">Email</th>
                                            <th className="table-head-cell">Company</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            experience.references.map((item) => {
                                                return (
                                                    <tr className="table-row" key={ item.uuid }>
                                                        <td className="table-cell">{ item.name }</td>
                                                        <td className="table-cell">
                                                            <a href={ `tel:${ item.phone }` }>
                                                                { item.phone }
                                                            </a>
                                                        </td>
                                                        <td className="table-cell">
                                                            <a href={ `mailto:${ item.email }` }>
                                                                { item.email }
                                                            </a>
                                                        </td>
                                                        <td className="table-cell">{ item.company }</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Gear details for { user.type_obj.label }

                                    <div style={{ float: 'right' }}>
                                        <Link to="/gear/primary">
                                            <Icon icon="gear" label="Update Info" large />
                                            Update Info
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <Link
                                    className="btn btn--primary"
                                    to="/gear/primary"
                                >
                                    View/edit your gear details
                                </Link>
                            </div>
                        </div>
                    </div>

                    { do {
                        if (user.crew_secondary_type) {
                            <div className="content__inner">
                                <div className="box">
                                    <div className="box__header">
                                        <div className="box__title">
                                            Gear details for { user.crew_secondary_type_obj.label }

                                            <div style={{ float: 'right' }}>
                                                <Link to="/gear/secondary">
                                                    <Icon icon="gear" label="Update Info" large />
                                                    Update Info
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box__content box__content--padded">
                                        <Link
                                            className="btn btn--primary"
                                            to="/gear/secondary"
                                        >
                                            View/edit your gear details
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        }
                    } }

                    { do {
                        if (user.crew_tertiary_type) {
                            <div className="content__inner">
                                <div className="box">
                                    <div className="box__header">
                                        <div className="box__title">
                                            Gear details for { user.crew_tertiary_type_obj.label }

                                            <div style={{ float: 'right' }}>
                                                <Link to="/gear/tertiary">
                                                    <Icon icon="gear" label="Update Info" large />
                                                    Update Info
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box__content box__content--padded">
                                        <Link
                                            className="btn btn--primary"
                                            to="/gear/tertiary"
                                        >
                                            View/edit your gear details
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        }
                    } }
                </div>
            </div>
        )
    }
}

export default Profile



// WEBPACK FOOTER //
// ./app/components/profile.js